import { useEffect, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocale } from './useLocale'

export function LocaleProvider({ children }: { children: ReactNode }) {
  const locale = useLocale()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale)
    }
    document.documentElement.lang = locale
  }, [locale, i18n])

  return <>{children}</>
}
